class OverlayInteractionListener {
	constructor(options = {}) {
		// Set default options and merge with provided options
		const defaults = {
			element: null,
			keys: ['Escape'],
			onKeyPress: null,
			onClickOutside: null,
			enabled: true,
		}
		this.options = { ...defaults, ...options }

		if (!this.options.element) {
			throw new Error('An element must be provided.')
		}

		this.element = this.options.element
		this.keys = this.options.keys
		this.onKeyPress = this.options.onKeyPress
		this.onClickOutside = this.options.onClickOutside
		this.enabled = false // Will be set in enable()

		// Bind event handlers
		this.boundKeyHandler = this.keyHandler.bind(this)
		this.boundClickHandler = this.clickHandler.bind(this)

		// Start enabled if configured to do so
		if (this.options.enabled) {
			this.enable()
		}
	}

	enable() {
		if (this.enabled) return
		document.addEventListener('keydown', this.boundKeyHandler)
		document.addEventListener('click', this.boundClickHandler)
		this.enabled = true
	}

	disable() {
		if (!this.enabled) return
		document.removeEventListener('keydown', this.boundKeyHandler)
		document.removeEventListener('click', this.boundClickHandler)
		this.enabled = false
	}

	keyHandler(e) {
		if (this.keys.includes(e.key) && typeof this.onKeyPress === 'function') {
			this.onKeyPress(e)
		}
	}

	clickHandler(e) {
		// If the click target is outside the provided element, trigger callback
		if (!this.element.contains(e.target) && typeof this.onClickOutside === 'function') {
			this.onClickOutside(e)
		}
	}

	destroy() {
		this.disable()
	}
}

export { OverlayInteractionListener }
